import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/stock/automatisation-blanc.png'
import _imports_1 from '@/assets/stock/symbole-doutil-rempli-de-filtre-blanc.png'
import _imports_2 from '@/assets/new-content/check-blanc.png'
import _imports_3 from '@/assets/stock/edit-button-blanc.png'
import _imports_4 from '@/assets/stock/supprimer-blanc.png'
import _imports_5 from '@/assets/stock/archiver-blanc.png'
import _imports_6 from '@/assets/new-content/photos.png'
import _imports_7 from '@/assets/stock/naviguez-pour-terminer-le-symbole-de-la-fleche-vers-la-droite-avec-la-barre-verticale-blanc.png'
import _imports_8 from '@/assets/modals/fleche-passer-au-suivant-blanc.png'


const _withScopeId = n => (_pushScopeId("data-v-016c8c8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("input", {
    type: "button",
    value: "Automatisation"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "action-buttons-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "button-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 })
], -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "table-container vld-parent" }
const _hoisted_18 = { class: "checkbox-container" }
const _hoisted_19 = { class: "checkbox" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "check-mark" }, null, -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "checkbox-container" }
const _hoisted_23 = ["for"]
const _hoisted_24 = ["id", "value"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "check-mark" }, null, -1))
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { key: 3 }
const _hoisted_35 = { class: "switch-container" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 4 }
const _hoisted_40 = { key: 5 }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "table-footer" }
const _hoisted_44 = {
  key: 0,
  class: "pagination-container"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-container prev-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_7 })
], -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-container prev-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_8 })
], -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { class: "count-container" }
const _hoisted_50 = ["value"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_8 })
], -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_7 })
], -1))
const _hoisted_54 = [
  _hoisted_53
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorModal = _resolveComponent("ErrorModal")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ActivityFilterModal = _resolveComponent("ActivityFilterModal")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.errorModalOpen)
      ? (_openBlock(), _createBlock(_component_ErrorModal, {
          key: 0,
          messages: $setup.errorMessage || [$setup.t('generic.error')],
          onClose: $setup.CloseErrorModal
        }, null, 8, ["messages", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Header, {
      title: $setup.t('components.sidebar.menu.stock'),
      onBack: $setup.GoBack
    }, {
      subHeader: _withCtx(() => [
        _createTextVNode(_toDisplayString($props.domName + ' - ' + $props.actName), 1)
      ]),
      middleButtons: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["button-container", { selected: $setup.activityFilterFormData.Levels.includes($setup.levelEasy) }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.ManageLevels($setup.levelEasy)))
        }, [
          _createElementVNode("input", {
            type: "button",
            value: $setup.t('generic.easy')
          }, null, 8, _hoisted_1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["button-container", { selected: $setup.activityFilterFormData.Levels.includes($setup.levelMedium) }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.ManageLevels($setup.levelMedium)))
        }, [
          _createElementVNode("input", {
            type: "button",
            value: $setup.t('generic.medium')
          }, null, 8, _hoisted_2)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["button-container", { selected: $setup.activityFilterFormData.Levels.includes($setup.levelHard) }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.ManageLevels($setup.levelHard)))
        }, [
          _createElementVNode("input", {
            type: "button",
            value: $setup.t('generic.difficult')
          }, null, 8, _hoisted_3)
        ], 2)
      ]),
      endButtons: _withCtx(() => [
        _hoisted_4,
        _createElementVNode("div", {
          id: "ActFilterButton",
          class: "button-container",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.activityFilterModalOpen = $setup.ToggleFilter($setup.activityFilterModalOpen)))
        }, [
          _hoisted_5,
          _createElementVNode("input", {
            type: "button",
            value: $setup.t('generic.filters')
          }, null, 8, _hoisted_6)
        ])
      ]),
      _: 1
    }, 8, ["title", "onBack"]),
    ($setup.activityFilterModalOpen)
      ? (_openBlock(), _createBlock(_component_ActivityFilterModal, {
          key: 1,
          filterFormData: $setup.activityFilterFormData,
          tableData: $setup.filteredTableValues,
          onApply: $setup.ApplyActivityFilter,
          onReset: $setup.ResetActivityFilter
        }, null, 8, ["filterFormData", "tableData", "onApply", "onReset"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: "button-container",
        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.ChangeAllDataStatus(true, $setup.selectedData)))
      }, [
        _hoisted_8,
        _createElementVNode("input", {
          type: "button",
          value: $setup.t('generic.enable')
        }, null, 8, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("input", {
          type: "button",
          value: $setup.t('generic.modify'),
          disabled: ""
        }, null, 8, _hoisted_12)
      ]),
      _createElementVNode("div", {
        class: "button-container",
        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.DeleteAllData($setup.selectedData)))
      }, [
        _hoisted_13,
        _createElementVNode("input", {
          type: "button",
          value: $setup.t('generic.delete')
        }, null, 8, _hoisted_14)
      ]),
      _createElementVNode("div", {
        class: "button-container",
        onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.ChangeAllDataStatus(false, $setup.selectedData)))
      }, [
        _hoisted_15,
        _createElementVNode("input", {
          type: "button",
          value: $setup.t('generic.disable')
        }, null, 8, _hoisted_16)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_loading, {
        active: $setup.isLoading,
        "onUpdate:active": _cache[7] || (_cache[7] = ($event: any) => (($setup.isLoading) = $event)),
        "can-cancel": false,
        "is-full-page": true
      }, null, 8, ["active"]),
      _createElementVNode("table", null, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.allSelected) = $event)),
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.SelectAllData && $setup.SelectAllData(...args)))
                  }, null, 512), [
                    [_vModelCheckbox, $setup.allSelected]
                  ]),
                  _hoisted_20
                ])
              ])
            ]),
            _createElementVNode("th", null, _toDisplayString($setup.t('generic.number')), 1),
            _createElementVNode("th", null, _toDisplayString($setup.t('generic.level')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tableData.headers, (header) => {
              return (_openBlock(), _createElementBlock("th", { key: header }, _toDisplayString(header), 1))
            }), 128)),
            ($setup.isActHasAssets)
              ? (_openBlock(), _createElementBlock("th", _hoisted_21, _toDisplayString(_ctx.$t('generic.assets')), 1))
              : _createCommentVNode("", true),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.stock.activity.dateOfAddOrModData')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.stock.activity.averageLife')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.stock.activity.whoAddedBDD')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('generic.status')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.stock.activity.dateOfArchiving')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.stock.activity.whoArchived')), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedItems, (row, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", {
                    for: row.id,
                    class: "checkbox"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      id: row.id,
                      type: "checkbox",
                      value: row.id,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.selectedData) = $event))
                    }, null, 8, _hoisted_24), [
                      [_vModelCheckbox, $setup.selectedData]
                    ]),
                    _hoisted_25
                  ], 8, _hoisted_23)
                ])
              ]),
              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
              _createElementVNode("td", null, _toDisplayString(row.level), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.data, (value, i) => {
                return (_openBlock(), _createElementBlock("td", { key: i }, [
                  (typeof value != 'boolean' && value == undefined)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, "/"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(value), 1))
                ]))
              }), 128)),
              (row.assets)
                ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                    _createElementVNode("div", {
                      class: "image-container",
                      onClick: ($event: any) => ($setup.DownloadAssets(row.assets))
                    }, _hoisted_31, 8, _hoisted_29)
                  ]))
                : ($setup.isActHasAssets)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_32, "/"))
                  : _createCommentVNode("", true),
              _createElementVNode("td", null, _toDisplayString($setup.convertDate(row.added)), 1),
              _createElementVNode("td", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ backgroundColor: $setup.GetColor(row.added) })
                  }, null, 4)
                ])
              ]),
              (row.whoadded.user !== ' ')
                ? (_openBlock(), _createElementBlock("td", _hoisted_33, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ backgroundColor: row.whoadded.bgColor })
                      }, _toDisplayString(row.whoadded.userCode), 5)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_34, "/")),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["switch", { 'switch-on': row.enable }]),
                    onClick: ($event: any) => ($setup.ChangeActDataStatus(!row.enable, [row.id]))
                  }, [
                    (row.enable)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString($setup.t('generic.active')), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString($setup.t('generic.inactive')), 1))
                  ], 10, _hoisted_36)
                ])
              ]),
              (!row.enable && row.archived)
                ? (_openBlock(), _createElementBlock("td", _hoisted_39, _toDisplayString($setup.convertDate(row.archived)), 1))
                : (_openBlock(), _createElementBlock("td", _hoisted_40, "/")),
              _createElementVNode("td", null, [
                (!row.enable && row.whoarchived.user !== ' ')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ backgroundColor: row.whoarchived.bgColor })
                      }, _toDisplayString(row.whoarchived.userCode), 5)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_42, "/"))
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      ($setup.pagination.totalPages > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            ($setup.pagination.currentPage > 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "button-container",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.pagination.currentPage > 1 ? (($setup.pagination.currentPage = 1), $setup.RemoveAllSelect()) : null))
                }, _hoisted_46))
              : _createCommentVNode("", true),
            ($setup.pagination.currentPage > 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "button-container",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.pagination.currentPage > 1 ? ($setup.pagination.currentPage--, $setup.RemoveAllSelect()) : null))
                }, _hoisted_48))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_49, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.pagination.currentPage) = $event)),
                onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => ($setup.RemoveAllSelect && $setup.RemoveAllSelect(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pagination.totalPages, (page) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: page,
                    value: page
                  }, _toDisplayString(page), 9, _hoisted_50))
                }), 128))
              ], 544), [
                [_vModelSelect, $setup.pagination.currentPage]
              ]),
              _createTextVNode(" " + _toDisplayString($setup.t('generic.of')) + " " + _toDisplayString($setup.pagination.totalPages), 1)
            ]),
            ($setup.pagination.currentPage < $setup.pagination.totalPages)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "button-container",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (
                    $setup.pagination.currentPage < $setup.pagination.totalPages
                        ? ($setup.pagination.currentPage++, $setup.RemoveAllSelect())
                        : null
                ))
                }, _hoisted_52))
              : _createCommentVNode("", true),
            ($setup.pagination.currentPage < $setup.pagination.totalPages)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "button-container",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (
                    $setup.pagination.currentPage < $setup.pagination.totalPages
                        ? (($setup.pagination.currentPage = $setup.pagination.totalPages), $setup.RemoveAllSelect())
                        : null
                ))
                }, _hoisted_54))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}